export default __webpack_public_path__ + "static/media/arrowSelectIcon.5b6b70e0.svg";